export enum PublicRoutes {
  login = '/',
  registerBrand = '/register/brand',
  registerCreator = '/register/creator',
  registerTeamMember = '/register/team-member',
  verifyEmail = '/email/verify',
  // login and password reset
  forgotPassword = '/recover-password',
  resetPassword = '/reset-password',
  // public campaign views
  campaignPublic = '/campaigns/:uuid/:view',
  // legacy routes (kept for backwards compatibility)
  campaignApplicantsPublic = '/campaigns/:uuid/applicants',
  campaignContentPublic = '/campaigns/:uuid/content',

  creatorPublic = '/creators/:uuid/:view',
  creatorProfilePublic = '/creators/:uuid/profile',
  creatorReviewsPublic = '/creators/:uuid/reviews',
  creatorPortfolioPublic = '/creators/:uuid/portfolio',
}
